// extracted by mini-css-extract-plugin
export default {"credits":"credits--JQwxc","logo":"logo--n46Pj","text":"text--QZ7Cw"};